import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const resendTemporaryPasswordEmailSlice = createSlice({
  name: 'resendTemporaryPasswordEmail',
  initialState: initialState.resendTemporaryPasswordEmail,
  reducers: {
    postResendInviteForPublicRequest(
      state,
      _action: PayloadAction<{ email: string }>,
    ) {
      state.isLoading = true;
      state.error = false;
    },
    postResendInviteForPublicResponse(
      state,
      _action: PayloadAction<{ success: boolean }>,
    ) {
      state.isLoading = false;
      state.success = true;
    },
    postResendInviteForPublicFailure(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.error = true;
    },
  },
});

export const {
  postResendInviteForPublicRequest,
  postResendInviteForPublicResponse,
  postResendInviteForPublicFailure,
} = resendTemporaryPasswordEmailSlice.actions;

export const resendTemporaryPasswordEmailReducer =
  resendTemporaryPasswordEmailSlice.reducer;
